import EventActionProto from '../event-action-proto'
import {SESSION_PROJECT_USERS_CHANGED, SESSION_PROJECTS_CHANGED} from "../../gd/bus/bus-event-type"
import Session_reinitNavigationStructure from "../functions/reinit-navigation-structure"
import Company from "../../model2/company/company";

const debug = false
// const debug = "EventProjectsAndUsersReset"


export default class EventProjectsAndUsersReset extends EventActionProto {

    constructor(sessionEvent: any) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId);
    }

    process() {

        debug && console.log(debug,"process");

        // akkuratno mi shlem etot event i posle full reset
        // when delete project user
        if (gd.companyId && this.isDifferentCompany()) {
            // console.log("diff. company -> igore");
            return false;
        }

        // akkuratno see projets reset i project users reset as this methodn combines both

        // if current app is project app settings transfer is required
        let relatedProjects = []
        let savedProjectsSettings : any = {}

        if (!!gd.app && !!gd.app.projectId) {
            const parentProjectsIds = gd.session.projects.getAllParents(gd.app.projectId).map(p=>p.id);
            const childrenProjectsIds = gd.session.projects.getAllChildren(gd.app.projectId).map(p=>p.id);
            relatedProjects = _.union(parentProjectsIds, childrenProjectsIds, [gd.app.projectId]);

            _.map(relatedProjects, projectId=>{
                const project = gd.session.projects.get(projectId);
                if (project) savedProjectsSettings[projectId] = project.settings;
            })
        }

        gd.session.projects.resetAndKeepOldModels(this.data.projects)
        gd.spaces?.workspaces.updateProjects()
        gd.bus.triggerEvent(SESSION_PROJECTS_CHANGED)

        // restore previously saved settings
        _.map(relatedProjects, projectId=>{
            const project = gd.session.projects.get(projectId);
            if (project && savedProjectsSettings[projectId]) project.settings = savedProjectsSettings[projectId];
        })

        gd.tree.companies.map((company:Company)=>{
            gd.tree.resetCompanyProjects(company.id)
        })

        // OK teper' project users
        gd.session.projectUsers.resetAndKeepOldModels(this.data.projectUsers)
        gd.bus.triggerEvent(SESSION_PROJECT_USERS_CHANGED)

        Session_reinitNavigationStructure()

    }
};